export const isValidDate = (year: number, month: number, day: number): boolean => {
  if (!year || !month || !day) return false;

  // Create a date object and verify the values match what was input
  const date = new Date(year, month - 1, day);
  return date.getFullYear() === year && date.getMonth() === month - 1 && date.getDate() === day;
};
